
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import t from "@common/src/i18n/t";

// isGroupParts(其实叫isPackage更合适后续看情况优化) 是否套餐项目; showGroup: 是否显示零配件组flag
const common_app = namespace("common_app");
const common_base = namespace("common_base");
const user = namespace("user");
const parts = namespace("parts");

@Component({ components: {} })
export default class PartsSelector extends Vue {
  // 正常零配件列表
  @Prop({ default: () => [], type: Array })
  partsList: any;
  // 零配件Data
  @Prop({ default: () => {}, type: Object })
  partsData: any;
  // 列表中的零配件Data
  @Prop({ default: () => {}, type: Object })
  scopeData: any;
  // 显示套餐
  @Prop({ default: false, type: Boolean })
  showGroup: boolean;
  // 显示提成
  @Prop({ default: false, type: Boolean })
  showCommission: boolean;
  @common_app.State lang;
  @common_base.State showPlatformParts;
  @user.State u8cStore;
  @parts.Action saveTempParts;
  // partsType 1标准 2临采
  noMatchingPartsName = "";
  searchParts(val) {
    this.noMatchingPartsName = val;
    this.$emit("search", val);
  }
  handleLinkQuickAddParts() {
    const href = this.$router.resolve(
      `/setting/parts-add?partsName=${encodeURIComponent(this.noMatchingPartsName)}`
    ).href;
    window.open(href);
  }
  additionPartsList = [];
  get allPartsList() {
    return [...this.partsList];
  }
  definitionPartsData: any = {
    partsCode: "",
    partsName: "",
    partsNameDesc: "",
    quantity: "",
    sellingPrice: "",
    technicianCode: [],
    saleCode: "",
    amount: "",
    remark: "",
    manual: true
  };
  async changeParts(partsCode, index) {
    this.$emit("change", partsCode, index);
  }
  get placeholderText() {
    if (this.partsData.partsRuleType === 2) {
      return this.partsData.partsName;
    } else if (this.partsData.partsRuleType === 3) {
      return this.partsData.partsName;
    } else {
      return t("parts.select-parts-tips");
    }
  }
  @Watch("partsData", { immediate: true, deep: true })
  partsDataChange() {
    this.$nextTick(() => {
      const perfixWidth = (this.$refs["com-parts-selector"] as any).querySelector(".el-input__prefix").offsetWidth;
      (this.$refs["com-parts-selector"] as any).querySelector(".el-input__inner").style["padding-left"] = `${
        perfixWidth + 6
      }px`;
    });
  }
  handleShowTempPurchase() {
    this.$emit("addTempPartsClick");
  }
}
